import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './index.module.scss';

type Props = {
	title: string;
	subtitle?: string;
	condition: boolean;
};

const TableCapabilities: FC<Readonly<Props>> = ({ title, subtitle, condition }) => {
	const { t } = useTranslation();

	return (
		<tr>
			<td>
				<p>{title}</p>

				{subtitle && ( // nosemgrep: eslint.react-dangerouslysetinnerhtml
					<small dangerouslySetInnerHTML={{ __html: subtitle }} />
				)}
			</td>

			<td>
				<strong className={condition ? styles.positive : styles.negative}>
					{condition ? t('YES') : t('NO')}
				</strong>
			</td>
		</tr>
	);
};

export default TableCapabilities;
